import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface CustomerSearch {
    name: string;
    showInactive: boolean;
    showResults: boolean;
    readOnly: boolean;
    canAdd: boolean;
    canSearch: boolean;
    result: CustomerList[];
    loading: boolean;
}

interface CustomerList {
    id: number;
    name: string;
    accountType: string;
    phone: string;
    status: string;
}

export class CustomerSearchData extends React.Component<RouteComponentProps<{}>, CustomerSearch> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: '',
            showInactive: false,
            showResults: false,
            readOnly: false,
            canAdd: false,
            canSearch: false,
            result: [],
            loading: true
        }; 
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckCustomerUserPermission?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.canEdit || res.data.canView || res.data.canCreateQuoteOnlyCustomer) {
                var readOnlyPermission = !res.data.canEdit && res.data.canView;
                var canAdd = res.data.canEdit || res.data.canCreateQuoteOnlyCustomer;
                var canSearch = res.data.canEdit || res.data.canView;
                this.setState({ loading: false, readOnly: readOnlyPermission, canAdd: canAdd, canSearch: canSearch });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addNew = () => {
        this.props.history.push("/customeradd")
    }

    handleChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.value;
        this.setState(change);
    }

    handleCheckboxChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.checked;
        this.setState(change)
    }

    reset = () => {
        this.setState({
            name: '',
            showInactive: false,
            result: [],
            showResults: false
        });
    }

    search = (e: any) => {
        e.preventDefault();
        
        //check to make sure at least one search field has been entered
        if (this.state.name) {
            this.searchCustomers();
        } else {
            this.setState({ showResults: false });
            toast.error("Please enter a customer name");
        }

    }

    async searchCustomers() {
        const token = await authService.getAccessToken();
        axios.get('api/Customer/SearchCustomer?Name=' + this.state.name + '&ShowInactive=' + this.state.showInactive, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ showResults: true, result: res.data });
        })
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderSearch();

        return <div>
            <div className="makeitflexspacebetween">
                <h1>Customer Search</h1>
                <button className={!this.state.canAdd ? "hidden" : "defaultbutton defaultbutton__small marginTop10"} type='button' onClick={this.addNew}>Add New</button>
            </div>
            {contents}
        </div>;
    }

    renderSearch = () => {
        return (<form onSubmit={this.search}>
            <div className="row">
                
            </div>
            <div>
                <label className="input-group--inline" htmlFor="name">
                    <span className="label label--setsizesm">Name</span>
                    <input className="input" type="text" id="name" name="name" value={this.state.name} onChange={(e) => this.handleChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="inactive">
                    <span className="label label--setsizesm">Show Inactive</span>
                    <input className="input" type="checkbox" id="inactive" name="showInactive" checked={this.state.showInactive} onChange={(e) => this.handleCheckboxChange(e)}></input>
                </label>
                <button className="defaultbutton" type='submit' disabled={!this.state.canSearch}>Search</button>
                <button className="defaultbutton marginLeft10" type='button' onClick={this.reset}>Reset</button>
            </div>
            <div>
                <hr></hr>
            </div>
            <div className={this.state.showResults ? 'overflowAuto' : 'hidden'}>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.result.map(customer =>
                            <tr key={customer.id}>
                                <td className="hidden">{customer.id}</td>
                                <td>{customer.name}</td>
                                <td>{customer.accountType}</td>
                                <td>{customer.phone}</td>
                                <td>{customer.status}</td>
                                <td>
                                    <Link to={'/customer/' + customer.id}>
                                        Open
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


        </form>);

    }
}

